import { EditGuesser } from '@api-platform/admin';
import { useRecordContext, EditBase } from 'react-admin';
import AudioPlayer from './AudioPlayer'; // Import the new AudioPlayer component
import { Box } from '@mui/material';

// Wrapper component to access the record context
const AudioPlayerWrapper = () => {
    const record = useRecordContext();
    if (!record) return null;
    return (
        <Box sx={{ m: 2 }}>
            <AudioPlayer audioFileUrl={record.mediaUrl} tracks={record.tracks} title={record.title} />
        </Box>
    );
};

const AudioEdit = () => (
    <EditBase>
        <AudioPlayerWrapper />
    </EditBase>
);

export default AudioEdit;
